









import { Component, Mixins, Watch } from "vue-property-decorator";
import { ModelEditableMixin } from "../mixins";

@Component({
})
export default class JsonEditor extends Mixins(ModelEditableMixin) {
  data(): any {
    return {
      editingString: JSON.stringify(this.editingSource, null , "  "),
      isValid: true,
    };
  }
  editingString: string;  // 編集中文字列.(編集中はparseできない事があるのでeditingSourceとは別管理.)
  isValid: boolean;

  mounted(): void {
    this.editingString = JSON.stringify(this.editingSource, null , "  ");
  }

  @Watch("editingSource")
  onEditingSourceChanged(newValue: any, oldValue: any) {
    this.editingString = JSON.stringify(this.editingSource, null , "  ");
  }

  get jsonString(): string {
    return this.editingString;
  }

  set jsonString(value: string) {
    this.editingString = value;
    try {
      const parsed = JSON.parse(value);
      this.editingSource = parsed;
      this.isValid = true;
    } catch {
      this.isValid = false;
    }
  }
}
